import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=7313bbc7&scoped=true&"
import script from "./Insights.vue?vue&type=script&lang=ts&"
export * from "./Insights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313bbc7",
  null
  
)

export default component.exports